import React from "react";
import styled from "styled-components";
import PerfectScrollbar from 'react-perfect-scrollbar'
import ConvertPixelToRem from "@helpers/convert.rem";
import RadiusGenerate from "@helpers/radius.generate";
import RadioListGroup from "@atoms/radio.list.group";
import CheckboxListGroup from "@atoms/checkbox.list.group";
import {isEmpty} from "@helpers/helpers";
import Icon from "@atoms/icon";
import {array_unique, prepend_array} from "@helpers/arrays";
import {useWindowSize} from "@helpers/windows.size";
import {propetyTypesIcons} from "../../../hooks/types";

function ListsContent({items, type, name, handleItems, footer, searchable, itemsPosition, select_optional, icon, topItems, setTopItems, limit_select, showSelectedItemsInTop}) {
    const handleClick = (event, value) => {
        const target = event.target;
        handleItems(value);

        if (!isEmpty(showSelectedItemsInTop) && showSelectedItemsInTop && process.browser && window.innerWidth < 768) {

            const checked = target.classList.contains('checked');
            let setNew = true;
            let selectedItems = [];
            if (topItems.length) {
                selectedItems = [...topItems];
            }

            if (selectedItems.length) {
                for (let key in selectedItems) {
                    const item = selectedItems[key];

                    if (item && typeof item.value !== "undefined" && item.value === value) {
                        setNew = false;
                        delete selectedItems[key];
                    }
                }
            }

            if (!checked && setNew && (!isEmpty(limit_select) && selectedItems.length < limit_select)) {
                const newItem = {label: target.innerText, value: value};
                selectedItems = prepend_array(newItem, selectedItems);
            }

            selectedItems = array_unique(selectedItems);
            setTopItems(selectedItems)
        }
    };

    let isHeaderInputs = searchable;
    if (type === "range") {
        isHeaderInputs = true;
    }

    return (
        <Container isHeaderInputs={isHeaderInputs} footer={footer} className={"selection-lists " + type + ' ' + (itemsPosition) + (select_optional ? ' select_optional ' : '')}>

            {items.map((item, key) => {

                if (select_optional) {
                    if (type === 'single') {
                        return <RadioListGroup className="mt-16" name={name} key={key} item={item} onChange={(e) => handleItems(e.target.value, false, false)}/>
                    } else {
                        if (item.isSsr && item.iconsType === 'property_types') {
                            item.icon = propetyTypesIcons[item.icon];
                            item.isSsr = false;
                        }

                        return <CheckboxListGroup itemKey={item.id} name={name} value={item.value} title={item.label} checked={item.checked} icon={item.icon} onChange={(e) => handleClick(e, e.target.value)} className={(typeof item.show !== "undefined" && !item.show) ? 'd-none' : ''}/>
                    }

                } else {
                    return (
                        <Item
                            position={itemsPosition}
                            key={key}
                            onClick={(e) => handleClick(e, item.value)}
                            className={(name + item.value + ' ') + type + " " + (item.checked ? "checked" : "")}
                        >
                            {
                                (!isEmpty(icon)) ?
                                    <span className="d-flex align-items-center">
                                        <Icon width={16} height={16}>{icon}</Icon>
                                        <span className="mr-8">{item.label}</span>
                                    </span>
                                    :
                                    item.label
                            }
                        </Item>
                    );
                }
            })}
        </Container>
    );
}

function Lists(props) {
    const windowSize = useWindowSize();

    if (windowSize > 991 && props.perfectScrollbar) {
        return (
            <PerfectScrollbar onScrollDown={(target) => props.handleItemsScroll(target, true)}>
                <ListsContent {...props}/>
            </PerfectScrollbar>
        )
    } else {
        return <ListsContent {...props}/>
    }
}

export default React.memo(Lists);

export const Container = styled.ul`
    min-width: 100%;
    max-height: 280px;
    text-align: right;
    list-style: none;
    margin: 0;
    padding-top: 0;
    
    &.range {
        padding-top: 8px;
       display: flex;
       flex-direction: column; 
       align-items: flex-start;
       
       &.left {
            align-items: flex-end;
       }
    }
    
    @media only screen and (max-width: ${props => props.theme.screenSmMax}) {
        height: calc(100% - ${props => (props.footer && props.isHeaderInputs) ? '169px' : (props.footer ? '129px' : (props.isHeaderInputs ? '104px' : '64px'))});
        max-height: calc(100% - ${props => (props.footer && props.isHeaderInputs) ? '169px' : (props.footer ? '129px' : (props.isHeaderInputs ? '104px' : '64px'))});
        margin: 0;
        padding-top: 24px;
        padding-bottom: 24px !important;
        overflow-y: auto;
        overflow-x: hidden;
    }
    
    &.select_optional {
        height: auto;
        padding: 0 24px;
    }
    
    @media only screen and (max-width: ${props => props.theme.screenSmMax}) {
        padding: 8px 24px;
    }
    
    .modal-filter-body &{
        height: auto;
        max-height: calc(100% - ${props => (props.footer && props.isHeaderInputs) ? '177px' : (props.footer ? '137px' : (props.isHeaderInputs ? '112px' : '72px'))});
    }
`;
// styles
const Item = styled.li`
    position: relative;
    padding: 8px 24px 8px 0;
    color: ${props => props.theme.black};
    font-size: ${ConvertPixelToRem(15)};
    font-weight: normal;
    line-height: 1;
    cursor: pointer;
    width: ${props => (props.type === 'range') ? '50%' : '100%'};

    @media (min-width: ${props => props.theme.screenSmMax}) {
        &:hover {
            background-color: ${props => props.theme.gray100};
        }
    }
    
    @media (min-width: ${props => props.theme.screenSmMax}) {
         .modal-filter-body & {
            padding: 12px 24px 12px 0;
        }
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        padding: 12px 0;
    }
    
    &.multiple {
        &:before {
            display: inline-block;
            content: '';
            width: 17px;
            height: 17px;
            margin-left: 8px;
            vertical-align: middle;
            ${RadiusGenerate('4px')};
            border: 1px solid ${props => props.theme.gray300};  
            
            @media (max-width: ${props => props.theme.screenSmMax}) {
                width: 24px;
                height: 24px;
            }
            
            @media (min-width: ${props => props.theme.screenXsMax}) {
                .modal-filter-body & {
                    position: absolute;
                    left: 24px;
                    margin-left: 0;
                    width: 24px;
                    height: 24px;
                    top: 50%;
                    transform: translate(0, -50%);
                    background-size: 16px 16px !important;
                }
            }
            
            @media (max-width: ${props => props.theme.screenXsMax}) {
                position: absolute;
                left: 0;
                margin-left: 0;
            }
        }
        
        &.checked {
            &:before {
                color: transparent;
                border-color: ${props => props.theme.primary};
                background: ${props => props.theme.primary} url('/_img/icons/ok-white.svg') no-repeat 49% 47%;
                background-size: 12px 12px;
                
                @media (max-width: ${props => props.theme.screenSmMax}) {
                    background-size: 16px 16px;
                }
            }
        }
    }
    
    &.range {
        width: 50%;
        text-align: center;
        clear: both;
    }
`;

